exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-upload .avatar[data-v-9b308934] {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n", ""]);

// exports
